/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

import { EventJudgeEventHomeDTO, EventJudgeModel, JudgeHelpMessageRequest, JudgeLoginRequest, UpdateJudgeProfileRequest } from './data-contracts';
import { ContentType, HttpClient, RequestParams } from './http-client';

export class EventJudge<SecurityDataType = unknown> extends HttpClient<SecurityDataType> {
  /**
   * No description
   *
   * @tags EventJudge
   * @name PingList
   * @request GET:/EventJudge/ping
   */
  pingList = (params: RequestParams = {}) =>
    this.request<string, any>({
      path: `/EventJudge/ping`,
      method: 'GET',
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags EventJudge
   * @name EventDetail
   * @request GET:/EventJudge/Event/{eventId}
   */
  eventDetail = (eventId: number, params: RequestParams = {}) =>
    this.request<EventJudgeModel[], any>({
      path: `/EventJudge/Event/${eventId}`,
      method: 'GET',
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags EventJudge
   * @name EventJudgeDetail
   * @request GET:/EventJudge/{eventJudgeId}
   */
  eventJudgeDetail = (eventJudgeId: number, params: RequestParams = {}) =>
    this.request<EventJudgeModel, any>({
      path: `/EventJudge/${eventJudgeId}`,
      method: 'GET',
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags EventJudge
   * @name EventJudgeDelete
   * @request DELETE:/EventJudge/{eventJudgeId}
   */
  eventJudgeDelete = (eventJudgeId: number, params: RequestParams = {}) =>
    this.request<void, any>({
      path: `/EventJudge/${eventJudgeId}`,
      method: 'DELETE',
      ...params,
    });
  /**
   * No description
   *
   * @tags EventJudge
   * @name EventJudgeCreate
   * @request POST:/EventJudge
   */
  eventJudgeCreate = (data: EventJudgeModel, params: RequestParams = {}) =>
    this.request<EventJudgeModel, any>({
      path: `/EventJudge`,
      method: 'POST',
      body: data,
      type: ContentType.Json,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags EventJudge
   * @name EventJudgeUpdate
   * @request PUT:/EventJudge
   */
  eventJudgeUpdate = (data: EventJudgeModel, params: RequestParams = {}) =>
    this.request<EventJudgeModel, any>({
      path: `/EventJudge`,
      method: 'PUT',
      body: data,
      type: ContentType.Json,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags EventJudge
   * @name ResetAccessCodeCreate
   * @request POST:/EventJudge/{eventJudgeId}/reset-access-code
   */
  resetAccessCodeCreate = (eventJudgeId: number, params: RequestParams = {}) =>
    this.request<void, any>({
      path: `/EventJudge/${eventJudgeId}/reset-access-code`,
      method: 'POST',
      ...params,
    });
  /**
   * No description
   *
   * @tags EventJudge
   * @name LoginCreate
   * @request POST:/EventJudge/login
   */
  loginCreate = (data: JudgeLoginRequest, params: RequestParams = {}) =>
    this.request<EventJudgeModel, any>({
      path: `/EventJudge/login`,
      method: 'POST',
      body: data,
      type: ContentType.Json,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags EventJudge
   * @name EventhomeDetail
   * @request GET:/EventJudge/eventhome/{eventJudgeId}/{eventId}
   */
  eventhomeDetail = (eventJudgeId: number, eventId: number, params: RequestParams = {}) =>
    this.request<EventJudgeEventHomeDTO, any>({
      path: `/EventJudge/eventhome/${eventJudgeId}/${eventId}`,
      method: 'GET',
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags EventJudge
   * @name SendHelpMessageCreate
   * @request POST:/EventJudge/send-help-message
   */
  sendHelpMessageCreate = (data: JudgeHelpMessageRequest, params: RequestParams = {}) =>
    this.request<void, any>({
      path: `/EventJudge/send-help-message`,
      method: 'POST',
      body: data,
      type: ContentType.Json,
      ...params,
    });
  /**
   * No description
   *
   * @tags EventJudge
   * @name ProfileUpdate
   * @request PUT:/EventJudge/{eventJudgeId}/profile
   */
  profileUpdate = (eventJudgeId: number, data: UpdateJudgeProfileRequest, params: RequestParams = {}) =>
    this.request<EventJudgeModel, any>({
      path: `/EventJudge/${eventJudgeId}/profile`,
      method: 'PUT',
      body: data,
      type: ContentType.Json,
      format: 'json',
      ...params,
    });
}
